import {useMemo} from 'react';
import {Platform} from 'react-native';
import {useLocation} from 'react-router-native';
import {getHostname} from '@infra/domain/model/Site/getHostname';
import {getAppSchema} from '@infra/domain/model/Site/getAppSchema';
import {paymentReturnPath} from '@modules/routing/routes.definition';

const isWeb = Platform.OS === 'web';

const isMobileBrowser = (): boolean => {
  if (!isWeb) return false;

  const MATCH_MOBILE = /^Mobile|iP(hone|od|ad)|Android|BlackBerry|IEMobile/i;
  const {userAgent = ''} = typeof navigator !== 'undefined' ? navigator : {};
  return !!userAgent.match(MATCH_MOBILE);
};

const getBaseRedirectUrlsByPlatform: () => Record<string, string> = () => {
  const hostname = getHostname();
  const appSchema = getAppSchema();
  return {
    android: `${appSchema}user`,
    ios: `${appSchema}user`,
    web: `${hostname}/web_redirect/user`,
  };
};

const getBaseRedirectUrl: () => string = () => {
  const baseUrls = getBaseRedirectUrlsByPlatform();
  return isMobileBrowser() ? baseUrls.web : baseUrls[Platform.OS];
};

const useRedirect = (): {returnUrl: string} => {
  const {pathname} = useLocation();
  const baseUrl = useMemo(getBaseRedirectUrl, []);

  return useMemo(() => {
    const cleanPathname = paymentReturnPath(pathname).replace(/^\//, '');
    return {returnUrl: `${baseUrl}/${cleanPathname}`};
  }, [baseUrl, pathname]);
};

export {useRedirect, getBaseRedirectUrl};
